<template>
    <v-btn class="white_highlight--text" color="secondary" @click="handleClick" :disabled="disabled">
        {{ $t(label) }}
        <v-icon v-if="icon != '' && icon != null" style="color: var(--v-white_highlight-base);">{{ icon }}</v-icon>
    </v-btn>
</template>
<script>
    export default {
        props: [
            'label',
            'icon',
            'disabled'
        ],
        data() {
            return {}
        },
        methods: {
            handleClick() {
                this.$emit('click')
            }
        }
    }
</script>